var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"commonBox alipayBox"},[_c('div',{staticStyle:{"margin-bottom":"10rem"}},[_vm._v("请复制该链接到浏览器支付：")]),_c('div',{staticStyle:{"color":"#027AFF"}},[_vm._v(" "+_vm._s(_vm.baseUrl)+"/alipay?itemId="+_vm._s(_vm.itemId)+"&logId="+_vm._s(_vm.logId)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }